var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEn(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 0H0V16H20V0Z",
    fill: "#F0F0F0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 1.99976H0V3.99956H20V1.99976Z",
    fill: "#D80027"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20 5.99988H0V7.99968H20V5.99988Z",
    fill: "#D80027"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20 9.99951H0V11.9993H20V9.99951Z",
    fill: "#D80027"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20 13.9996H0V15.9994H20V13.9996Z",
    fill: "#D80027"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10 0H0V8.61539H10V0Z",
    fill: "#2E52B2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M3.89928 3.5293L3.73822 4.12385H3.21729L3.63881 4.49112L3.47775 5.08562L3.89928 4.71836L4.32053 5.08562L4.15951 4.49112L4.58104 4.12385H4.06006L3.89928 3.5293Z",
    fill: "#F0F0F0"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M4.06006 6.26944L3.89928 5.67493L3.73822 6.26944H3.21729L3.63881 6.63674L3.47775 7.23125L3.89928 6.86395L4.32053 7.23125L4.15951 6.63674L4.58104 6.26944H4.06006Z",
    fill: "#F0F0F0"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M1.85844 6.26944L1.69762 5.67493L1.53656 6.26944H1.01562L1.43715 6.63674L1.27609 7.23125L1.69762 6.86395L2.11891 7.23125L1.95789 6.63674L2.37934 6.26944H1.85844Z",
    fill: "#F0F0F0"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M1.69762 3.5293L1.53656 4.12385H1.01562L1.43715 4.49112L1.27609 5.08562L1.69762 4.71836L2.11891 5.08562L1.95789 4.49112L2.37934 4.12385H1.85844L1.69762 3.5293Z",
    fill: "#F0F0F0"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M3.89928 1.38367L3.73822 1.97827H3.21729L3.63881 2.34558L3.47775 2.94009L3.89928 2.57278L4.32053 2.94009L4.15951 2.34558L4.58104 1.97827H4.06006L3.89928 1.38367Z",
    fill: "#F0F0F0"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M1.69762 1.38391L1.53656 1.97851H1.01562L1.43715 2.34582L1.27609 2.94033L1.69762 2.57302L2.11891 2.94033L1.95789 2.34582L2.37934 1.97851H1.85844L1.69762 1.38391Z",
    fill: "#F0F0F0"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M6.1009 3.5293L5.93988 4.12385H5.41895L5.84043 4.49112L5.67945 5.08562L6.1009 4.71836L6.52223 5.08562L6.36117 4.49112L6.78269 4.12385H6.26176L6.1009 3.5293Z",
    fill: "#F0F0F0"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M6.26176 6.26944L6.1009 5.67493L5.93988 6.26944H5.41895L5.84043 6.63674L5.67945 7.23125L6.1009 6.86395L6.52223 7.23125L6.36117 6.63674L6.78269 6.26944H6.26176Z",
    fill: "#F0F0F0"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M8.46338 6.26944L8.30256 5.67493L8.1415 6.26944H7.62061L8.04205 6.63674L7.88104 7.23125L8.30256 6.86395L8.72385 7.23125L8.56279 6.63674L8.98432 6.26944H8.46338Z",
    fill: "#F0F0F0"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M8.30256 3.5293L8.1415 4.12385H7.62061L8.04205 4.49112L7.88104 5.08562L8.30256 4.71836L8.72385 5.08562L8.56279 4.49112L8.98432 4.12385H8.46338L8.30256 3.5293Z",
    fill: "#F0F0F0"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M6.1009 1.38367L5.93988 1.97827H5.41895L5.84043 2.34558L5.67945 2.94009L6.1009 2.57278L6.52223 2.94009L6.36117 2.34558L6.78269 1.97827H6.26176L6.1009 1.38367Z",
    fill: "#F0F0F0"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M8.30268 1.38367L8.14163 1.97827H7.62073L8.04217 2.34558L7.88116 2.94009L8.30268 2.57278L8.72397 2.94009L8.56291 2.34558L8.98444 1.97827H8.4635L8.30268 1.38367Z",
    fill: "#F0F0F0"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEn);
export default __webpack_public_path__ + "static/media/en.71c384f7.svg";
export { ForwardRef as ReactComponent };